import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {ConfigurationService} from '../../../../services/common/configuration/configuration.service';
import _ from 'lodash';

@AcDialog({
  width: 550,
  height: 500
})
@Component({
  selector: 'time-based-routing-dialog',
  templateUrl: './time-based-routing-dialog.component.html',
  styleUrls: ['./time-based-routing-dialog.component.scss']
})
export class TimeBasedRoutingDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('tbrDialog') tbrDialog: NgForm;
  tbr;
  tbrForSubmit;

  isEditMode: boolean;
  timeZoneOffset: any;
  dateNow: Date;
  datePickerOptions;

  typeOptions = [{text: 'Daily', value: 'DAILY'}, {text: 'Weekly', value: 'WEEKLY'}];

  hoursOptions = [
    {text: '00', value: 0}, {text: '01', value: 1}, {text: '02', value: 2},
    {text: '03', value: 3}, {text: '04', value: 4}, {text: '05', value: 5},
    {text: '06', value: 6}, {text: '07', value: 7}, {text: '08', value: 8},
    {text: '09', value: 9}, {text: '10', value: 10}, {text: '11', value: 11},
    {text: '12', value: 12}, {text: '13', value: 13}, {text: '14', value: 14},
    {text: '15', value: 15}, {text: '16', value: 16}, {text: '17', value: 17},
    {text: '18', value: 18}, {text: '19', value: 19}, {text: '20', value: 20},
    {text: '21', value: 21}, {text: '22', value: 22}, {text: '23', value: 23}];

  minutesOptions = [
    {text: '00', value: 0}, {text: '05', value: 5}, {text: '10', value: 10},
    {text: '15', value: 15}, {text: '20', value: 20}, {text: '25', value: 25},
    {text: '30', value: 30}, {text: '35', value: 35}, {text: '40', value: 40}, {text: '45', value: 45},
    {text: '50', value: 50}, {text: '55', value: 55}];

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private configurationService: ConfigurationService) {
    this.tbrForSubmit = dialogConfig.dialogData.tbrForSubmit;
    this.isEditMode = dialogConfig.dialogData.isEditMode;
    this.dialogConfig.submitButtonDisabled = true;
  }

  ngAfterViewInit(): void {
    this.tbrDialog.form.statusChanges.subscribe(() => {
      this.setSubmitButtonDisabled();
    });
  }

  setSubmitButtonDisabled(): boolean{
    return this.dialogConfig.submitButtonDisabled = !this.tbrDialog.form.valid ||
      (this.tbr.type === 'DAILY' && !this.tbr.daily.allDay && !this.timeRangeIsLegal(this.tbr.daily.startTime, this.tbr.daily.endTime))
      || (this.tbr.type === 'WEEKLY' && !this.tbr.days.MON.use && !this.tbr.days.TUE.use && !this.tbr.days.WED.use
        && !this.tbr.days.WED.use &&  !this.tbr.days.THU.use && !this.tbr.days.FRI.use &&
        !this.tbr.days.SAT.use && !this.tbr.days.SUN.use) || this.isAnyDayInvalid()
      || this.tbr.type === 'DAILY' && !this.tbr.usePeriod && (this.tbr.daily.allDay ||
        (this.tbr.daily.endTime.hours === 0 && this.tbr.daily.endTime.minutes === 0
          && this.tbr.daily.startTime.hours === 0 && this.tbr.daily.startTime.minutes === 0));
  }

  ngOnInit(): void {
    this.datePickerOptions = this.configurationService.getDatePickerOptions();
    this.initializeDates();
    this.initializeTbrObject();

    if (this.isEditMode) {
      try {
        this.initializeExistingTimeCondition();
      }catch (err){
        console.log(err);
      }
    }

    this.dialogConfig.preSubmit = () => {
      try {
        this.constructTimeCondition();
      }catch (err){
        console.log(err);
      }
      console.log(this.tbrForSubmit);
      return true;
    };
  }

  private initializeDates(): void {
    this.dateNow = new Date();
    this.timeZoneOffset = this.dateNow.getTimezoneOffset();
  }

  private initializeTbrObject(): void {
    this.tbr = {};
    this.tbr.name = '';
    this.tbr.type = 'DAILY';
    this.tbr.usePeriod = false;
    this.tbr.daily = {};
    this.tbr.daily.startTime = {hours: 0, minutes: 0};
    this.tbr.daily.endTime = {hours: 0, minutes: 0};

    this.tbr.daily.allDay = false;
    this.tbr.selectedDay = 'MON';

    this.tbr.days = {
      MON: {
        fullName: 'monday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      },
      TUE: {
        fullName: 'tuesday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      },
      WED: {
        fullName: 'wednesday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      },
      THU: {
        fullName: 'thursday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      },
      FRI: {
        fullName: 'friday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      },
      SAT: {
        fullName: 'saturday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      },
      SUN: {
        fullName: 'sunday',
        startTime: {hours: 0, minutes: 0},
        endTime: {hours: 0, minutes: 0},
        use: false,
        allDay: true
      }
    };

    this.initializeDateModel();
  }

  initializeExistingTimeCondition(): void {

    this.tbr.name = this.dialogConfig.dialogData.tbr.name;

    this.setDateObj();

    switch (this.dialogConfig.dialogData.tbr.type) {
      case 'DAILY':
        this.initializeDailyType();
        break;
      case 'WEEKLY':
        this.initializeWeeklyType();
        break;
      case 'PERIOD':
        this.initializePeriodType();
        break;
    }
  }

  setDateObj(): void {
    if (_.isNil(this.dialogConfig.dialogData.tbr.startDateTime) || _.isNil(this.dialogConfig.dialogData.tbr.endDateTime)) { return; }

    const start = new Date(this.dialogConfig.dialogData.tbr.startDateTime);
    start.setHours(start.getUTCHours(), start.getUTCMinutes(), start.getUTCSeconds(), start.getUTCMilliseconds());

    const end = new Date(this.dialogConfig.dialogData.tbr.endDateTime);
    end.setHours(end.getUTCHours(), end.getUTCMinutes(), end.getUTCSeconds(), end.getUTCMilliseconds());

    this.tbr.date = {
      startDateTime: {_d: start},
      endDateTime: {_d: end}
    };
  }

  initializeDailyType(): void {
    this.tbr.usePeriod = false;
    this.tbr.type = 'DAILY';
    this.initializeDailyTime();
  }

  initializeWeeklyType(): void {
    this.tbr.usePeriod = false;
    this.tbr.type = 'WEEKLY';
    this.initializeDays();
  }

  initializePeriodType(): void {
    this.tbr.usePeriod = true;
    if (this.isPeriodDaily()) {
      this.tbr.type = 'DAILY';
      this.initializeDailyTime();
    } else {
      this.tbr.type = 'WEEKLY';
      this.initializeDays();
    }
  }

  initializeDays(): void {
    this.dialogConfig.dialogData.tbr.days.forEach((day) => {
      this.tbr.days[day.day].use = true;
      if (day.startTime === null && day.endTime === null) {
        this.tbr.days[day.day].allDay = true;
        this.tbr.days[day.day].startTime.hours = 0;
        this.tbr.days[day.day].startTime.minutes = 0;
        this.tbr.days[day.day].endTime.hours = 0;
        this.tbr.days[day.day].endTime.minutes = 0;
      } else {
        this.tbr.days[day.day].allDay = false;
        this.tbr.days[day.day].startTime.hours = this.getHoursFromTimeString(day.startTime);
        this.tbr.days[day.day].startTime.minutes = this.getMinutesFromTimeString(day.startTime);
        this.tbr.days[day.day].endTime.hours = this.getHoursFromTimeString(day.endTime);
        this.tbr.days[day.day].endTime.minutes = this.getMinutesFromTimeString(day.endTime);
      }
    });
  }

  initializeDailyTime(): void {
    if (this.dialogConfig.dialogData.tbr.days[0].startTime !== null) {
      this.tbr.daily.allDay = false;
      const startTime  = {
        hours : this.getHoursFromTimeString(this.dialogConfig.dialogData.tbr.days[0].startTime),
        minutes: this.getMinutesFromTimeString(this.dialogConfig.dialogData.tbr.days[0].startTime)
      };
      const endTime = {
        hours : this.getHoursFromTimeString(this.dialogConfig.dialogData.tbr.days[0].endTime),
        minutes: this.getMinutesFromTimeString(this.dialogConfig.dialogData.tbr.days[0].endTime)
      };

      this.tbr.daily.startTime = startTime;
      this.tbr.daily.endTime = endTime;
    } else {
      this.tbr.daily.allDay = true;
      this.tbr.daily.startTime = {hours: 0, minutes: 0};
      this.tbr.daily.endTime = {hours: 0, minutes: 0};
    }
  }

  isPeriodDaily(): boolean {
    if (this.dialogConfig.dialogData.tbr.days.length === 7) {
      for (let i = 0; i < 6; i++) {
        if (!_.isEqual(this.dialogConfig.dialogData.tbr.days[i + 1].startTime, this.dialogConfig.dialogData.tbr.days[i].startTime)) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  getHoursFromTimeString(timeString): number {
    return timeString === null ? 0 : parseInt(timeString.split(':')[0], 10);
  }

  getMinutesFromTimeString(timeString): number {
    return timeString === null ? 0 : parseInt(timeString.split(':')[1], 10);
  }

  initializeDateModel(): void {
    const defaultStartDate = new Date(Date.now());
    defaultStartDate.setHours(0, 0, 0, 0);

    const defaultEndDate = new Date(Date.now());
    defaultEndDate.setHours(23, 59, 0, 0);

    this.tbr.date = {
      startDateTime: {_d: defaultStartDate},
      endDateTime: {_d: defaultEndDate}
    };
  }

  timeRangeIsLegal(startTime, endTime): boolean {
    if (endTime.hours === 0 && endTime.minutes === 0) {
      return true;
    }
    return startTime.hours <= endTime.hours && !(startTime.hours === endTime.hours && startTime.minutes >= endTime.minutes);
  }

  toLocalTimeString(dateTimeObject): string {
    const localDate = dateTimeObject._d;
    const date = new Date(Date.UTC(localDate.getFullYear(),
      localDate.getMonth(), localDate.getDate(),
      localDate.getHours(), localDate.getMinutes(), 0));
    return date.toLocaleString('en-GB',
      { hour12: false, year: '2-digit', month: '2-digit', day: '2-digit',  hour: '2-digit', minute: '2-digit'});
  }

  chooseDay(day): void {
    if (_.isEqual(this.tbr.selectedDay, day)) {
      this.tbr.days[day].use = !this.tbr.days[day].use;
    }
    this.tbr.selectedDay = day;

    this.setSubmitButtonDisabled();
  }

  constructTimeCondition(): void {

    this.tbrForSubmit.name = this.tbr.name;
    this.tbrForSubmit.type = this.tbr.type;
    this.tbrForSubmit.days = [];

    switch (this.tbr.type) {
      case 'DAILY':
        this.constructDaysFromDaily();
        break;
      case 'WEEKLY':
        this.constructDaysFromWeekly();
        break;
    }
    this.constructPeriod();
  }

  constructPeriod(): void {
    if (this.tbr.usePeriod) {
      this.tbrForSubmit.type = 'PERIOD';
      this.tbrForSubmit.startDateTime = this.constructDate(this.tbr.date.startDateTime._d);
      this.tbrForSubmit.endDateTime = this.constructDate(this.tbr.date.endDateTime._d);
    } else {
      this.tbrForSubmit.startDateTime = null;
      this.tbrForSubmit.endDateTime = null;
    }
  }

  constructDate(dateTimeObject): string {
    const year = dateTimeObject.getFullYear();
    const month = dateTimeObject.getMonth() + 1 > 9 ? dateTimeObject.getMonth() + 1 : '0' + (dateTimeObject.getMonth() + 1);
    const date = dateTimeObject.getDate() > 9 ? dateTimeObject.getDate() : '0' + dateTimeObject.getDate();
    const hours = dateTimeObject.getHours() > 9 ? dateTimeObject.getHours() : '0' + dateTimeObject.getHours();
    const minutes = dateTimeObject.getMinutes() > 9 ? dateTimeObject.getMinutes() : '0' + dateTimeObject.getMinutes();
    return year + '-' + month + '-' + date + 'T' + hours + ':' + minutes + ':00.000Z';
  }

  constructDaysFromDaily(): void {
    for (const day in this.tbr.days) {
      if (this.tbr.days.hasOwnProperty(day)) {
        this.tbrForSubmit.days.push(
          this.constructDay(day, this.tbr.daily)
        );
      }
    }
  }

  constructDaysFromWeekly(): void {
    for (const day in this.tbr.days) {
      if (this.tbr.days.hasOwnProperty(day)) {
        if (this.tbr.days[day].use) {
          this.tbrForSubmit.days.push(
            this.constructDay(day, this.tbr.days[day])
          );
        }
      }
    }
  }

  constructDay(dayKey, dayValue): any {
    if (dayValue.allDay || (dayValue.endTime.hours === 0 && dayValue.endTime.minutes === 0 &&
      dayValue.startTime.hours === 0 && dayValue.startTime.minutes === 0)) {
      return {
        day: dayKey,
        startTime: null,
        endTime: null
      };
    } else {
      const startHours = dayValue.startTime.hours > 9 ? dayValue.startTime.hours : '0' + dayValue.startTime.hours;
      const endHours = dayValue.endTime.hours > 9 ? dayValue.endTime.hours : '0' + dayValue.endTime.hours;
      const startMinutes = (dayValue.startTime.minutes > 9 ? dayValue.startTime.minutes : '0' + dayValue.startTime.minutes) + ':00.000';
      const endMinutes = (dayValue.endTime.minutes > 9 ? dayValue.endTime.minutes : '0' + dayValue.endTime.minutes) + ':00.000';

      return {
        day: dayKey,
        startTime: startHours + ':' + startMinutes,
        endTime: (dayValue.endTime.hours === 0 && dayValue.endTime.minutes === 0) ? null : endHours + ':' + endMinutes
      };
    }
  }

  private isAnyDayInvalid(): boolean {
    for (const day in this.tbr.days) {
      if (this.tbr.days[day].use && !this.timeRangeIsLegal(this.tbr.days[day].startTime, this.tbr.days[day].endTime)){
        return true;
      }
    }
    return false;
  }
}
